export default __webpack_public_path__ + "static/media/brainstar-01.e725b736.png";